import React from 'react';
import { string, object, bool } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Tag, Icon } from '@fiverr-private/fit';
import { Tooltip } from '@fiverr-private/tooltip';
import { EducationTooltip } from '@fiverr-private/orca';
import { QuestionSolidIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers';
import EducationTooltipTitle from './EducationTooltipTitle';
import TooltipContent from './TooltipContent';
import './style.scss';

const NewTag = () => (<Tag color={Tag.COLORS.PINK} className="m-l-8 cursor-default">
    <I18n k="portfolio_presence.new"/>
</Tag>);

const PortfolioPresenceHeader = ({ tooltipProps = {}, link, learnMoreLink, educate, portfolioTitle: customTitle }) => {
    const Title = link ? 'a' : 'h5';
    const portfolioTitle = customTitle ? customTitle : translate('portfolio_presence.title');

    return (
        <div className="presence-header flex m-b-16">
            <Title href={link} className="tbody-5 m-r-8">
                {portfolioTitle}
            </Title>
            <Tooltip content={<div className="portfolio-presence-tooltip-wrap"><TooltipContent tooltipProps={tooltipProps} learnMoreLink={learnMoreLink}/></div>}
                position="top">
                <span className="flex">
                    <Icon size={16} color={grey_900}>{QuestionSolidIcon}</Icon>
                </span>
            </Tooltip>
            { educate ? <EducationTooltip title={<EducationTooltipTitle/>}
                body={<I18n k="portfolio_presence.educate.body"/>}
                closeTitle={<I18n k="portfolio_presence.educate.gotit"/>}
                position={EducationTooltip.POSITIONS.TOP}
                tooltipStorageKey="portfolio_presence_education"
                appendToBody={true}>
                <NewTag/>
            </EducationTooltip> : <NewTag/>}
        </div>
    );
};

PortfolioPresenceHeader.propTypes = {
    tooltipProps: object.isRequired,
    link: string,
    learnMoreLink: string,
    educate: bool,
    portfolioTitle: string
};

export default PortfolioPresenceHeader;
